import { t } from 'localization/utils/t';

const TP = 'homepage.components.enums.tabConstants';

export const TAB_TITLES = {
  DISCOVER: {
    value: t(`${TP}.discover`, 'Discover'),
    TK: 'discover',
    TP,
  },
  BRAND: {
    value: t(`${TP}.brand`, 'Brand'),
    TK: 'brand',
    TP,
  },
};
